(function () {
	'use strict';

	window.mq = window.mq || {};

	/* Taken from /features/shared/scss/_variables.scss
	"phablet"		: 640px,
	"tablet"		: 768px,
	"desktop"		: 1024px,
	"desktop-large"	: 1280px,
	"desktop-xlarge": 1600px
	*/

	// min-width
	mq.phablet = window.matchMedia("(min-width: 640px)");
	mq.phabletX = window.matchMedia("(min-width: 690px)");
	mq.tablet = window.matchMedia("(min-width: 768px)");
	mq.desktop = window.matchMedia("(min-width: 1024px)");
	mq.desktopLarge = window.matchMedia("(min-width: 1280px)");
	mq.desktopXLarge = window.matchMedia("(min-width: 1600px)");

	// max-width
	mq.mobile = window.matchMedia("(max-width: 499px)");
	mq.smallerThanPhablet = window.matchMedia("(max-width: 640px)");

})();